export default "__VITE_ASSET__CnmKQUf2__"